import React from 'react'
import { isSjDomain } from 'utils/domain'

import SjGlobalFooter from './SjGlobalFooter'

/**
 * グローバルフッター・全ての画面に適用するフッター
 */
const GlobalFooterArea: React.FC = () => {
  return <React.Fragment>{isSjDomain() && <SjGlobalFooter />}</React.Fragment>
}

export default GlobalFooterArea
